export default function Footer() {
    return (
      <footer>
            <span>Powered by CrowdClix </span>
      </footer>
    );
  }